import { GlobalStyles, lightTheme, MeetingProvider } from 'amazon-chime-sdk-component-library-react';
import { ThemeProvider } from 'styled-components';
import ConfirmVideo from './confirm';

const WrappedMeetingPage = (props) => {
  let device = props.device;
  const handleOpenVideo = (flag) => {
    props.handleOpenVideo(flag);
  };

  const handleEndChatSession = () => {
    props.handleEndChatSession();
  };

  const handleEndVideo = () => {
    props.handleEndVideo();
  };

  return (
    <ThemeProvider theme={lightTheme}>
      <GlobalStyles />
      <MeetingProvider>
        <ConfirmVideo
          chatConfig={props.chatConfig}
          initiateChatRequest={props.initiateChatRequest}
          setContactId={props.setContactId}
          handleOpenVideo={(flag) => handleOpenVideo(flag)}
          device={device}
          handleEndChatSession={handleEndChatSession}
          setEvaluationState={props.setEvaluationState}
          handleEndVideo={handleEndVideo}
        />
      </MeetingProvider>
    </ThemeProvider>
  );
};

export default WrappedMeetingPage;
